<div class="info-block">
  <div class="header-block">
    <h2 class="title">
      {{ "ANALYTICS_PAGE.REQUESTS" | translate }}
    </h2>
    <button *appHasAccess="['SUPPORT_VIEW']" (click)="router.navigate(['/support'])" class="watch-btn">
      <img src="assets/img/watch.svg" alt="" />
      <span> {{ "ANALYTICS_PAGE.SEE_ALL" | translate }}</span>
    </button>
  </div>

  <hr />

  <div *ngIf="requestData" class="requests-list">
    <div *ngFor="let item of requestData" class="requests-list__item">
      <span class="item-type">{{
        "ANALYTICS_PAGE." + item.support_type | translate
      }}</span>
      <div class="item-rounds">
        <div class="round green">
          {{ item.support_type_statistics[0].quantity }}
        </div>
        <div class="round blue">
          {{ item.support_type_statistics[1].quantity }}
        </div>
        <div class="round orange">
          {{ item.support_type_statistics[2].quantity }}
        </div>
      </div>
    </div>
  </div>
</div>
